import React, {Fragment} from "react";
import {Breadcrumbs, Paper, Typography, withStyles, Container} from '@material-ui/core';
import autoBind from 'react-autobind';
import {desconhecidoEntrarSessao, sessionBySlugAndParticipantQuery} from '../../graphql/Sessao';
import { Query, Mutation, withApollo } from "react-apollo";
import { Formik } from 'formik';
import moment from 'moment';
import {Col, Row, Form, Button} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import { Link } from "react-router-dom";
import {gerenciarSalasSave} from "../../graphql/Salas";
import {desconhecidoDefineDados} from "../../graphql/Outros";
import Swal from 'sweetalert2';
import Login from "../auth/Login";
const { Control, Group, Label } = Form;
const { PUBLIC_URL } = process.env;

const styles = theme => ({
    root: {
        padding: theme.spacing(3, 2),
        minHeight: '100vh'
    },
    logo: {
        paddingBottom: "30px"
    },
    form: {
        minWidth: "40vw",
        padding: "20px",
        minHeight: "385px"
    },
    tituloSessao: {
        lineHeight: '35px',
        verticalAlign: 'middle',
        textAlign: 'center',
        fontSize: '32px',
        padding: '30px'
    },
    tituloContainer: {
        minHeight: '50px',
        background: 'white',
        marginBottom: '25px'
    },
    input: {
        height: "30px",
        marginBottom: "5px"
    },
    button: {
        marginTop: "10px",
        paddingLeft: "30px",
        paddingRight: "30px",
        fontWeight: 500
    },
    chronometerWrapper: {
        margin: '0 auto',
        fontSize: '32px',
        fontWeight: '500'
    },
    flexItem: {
        textAlign: 'center',
        marginTop: '30px'
    },
    countDownWraper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: "190px",
        marginLeft: '8px',
        marginRight: '8px',
    },
    countDownItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '25%'
    },
    timerNumber: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "#f5b500",
        textAlign: 'center',
        fontWeight: '400',
        fontSize: '10vw',
        border: 'solid 2px #f1f1f1',
        lineHeight: '95px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '25px',
        paddingBottom: '25px',
        width: '15vw',
        height: '15vw'
    },
    timerText: {
        fontSize: '3vw',
        color: "#949491",
        fontWeight: '500',
        textAlign: 'center',
        padding: '10px',
    },
    footerMessage: {
        fontSize: '14px'
    }
});

class DesconhecidoAcessarSala extends React.Component {

    constructor(props) {
        super(props);
        const {slug} = props.match.params;
        this.state = {
            slug,
            difference: null,
            _v: 0
        }
        autoBind(this);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {sessaoAndamentoUrl, slug} = this.state;
        const {history} = this.props;

        if (!prevState.sessaoAndamentoUrl && sessaoAndamentoUrl) {
            document.location.href = sessaoAndamentoUrl;
        }
    }

    notifyChange() {
        this.setState({ _v: this.state._v + 1 });
    }

    render() {
        const {classes} = this.props;
        return (
            <Paper className={[classes.root, "acesso-usuario-desconhecido"]}>
                <Row className={["justify-content-md-center", classes.logo]}>
                    <Col md="auto">
                        <img src={ PUBLIC_URL + "/media/logos/logo.png"}/>
                    </Col>
                </Row>
                <Row className={["justify-content-md-center"]}>
                    <Col md="auto">
                        {this.loadSessionData()}
                    </Col>
                </Row>
            </Paper>
        );
    }

    renderBreadCrumb() {
        return <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
            <Typography>Participar</Typography>
            <div>Acessar sala</div>
        </Breadcrumbs>;
    }

    handleSaveForm(data) {
        console.log("handleSaveForm");

        const { client } = this.props;

        client.mutate({
            mutation: desconhecidoDefineDados,
            variables: { input: Mutation.cleanupData(data) },
        }).then((data) => {
            this.setState({desconhecidoSessionId: data.data.desconhecidoDefineDados, desconhecidoForm: data});
        });
    }

    loadSessionData() {
        this._queryVariables = {
            slug: this.state.slug
        }

        return (
            <Query query={sessionBySlugAndParticipantQuery} variables={{...this._queryVariables}}
                   fetchPolicy='network-only'>
                {({data, loading, error, refetch}) => {
                    if (loading) return 'Carregando ...';
                    if (error) return `Error! ${error.message}`;
                    if (!data.sessionBySlugAndParticipant) return <p>Sessão não encontrada</p>;

                    const {classes} = this.props;
                    const {horaAtualQuery, sessionBySlugAndParticipant: sessionData} = data;
                    const {inicio, fim} = sessionData;

                    const momentSessionInicio = moment(inicio).utc().format();
                    const momentSessionFim = moment(fim).utc().format();

                    const horaAtual = this.state.serverTime || moment(horaAtualQuery.value).utc().format();

                    //sessao cancelada
                    if (sessionData.is_archive) {
                        return <div className={classes.flexItem}>
                            <span>A sessão <strong>{sessionData.nome}</strong> foi cancelada.</span>
                        </div>;
                    }

                    //sessao encerrada
                    if (momentSessionFim < moment(horaAtual).format()) {
                        return <div className={classes.flexItem}>
                            <span>A sessão <strong>{sessionData.nome}</strong> já foi encerrada.</span>
                        </div>;
                    }

                    if(this.state.desconhecidoForm) {
                        //sessao em andamento
                        if (momentSessionInicio <= moment(horaAtual).format() && momentSessionFim > moment(horaAtual).format()) {
                            return this.sessaoAndamento();
                        }

                        //sessao agendada
                        if (momentSessionInicio >= moment(horaAtual).format()) { //sessao agendada
                            return this.sessaoAgendada(momentSessionInicio, horaAtualQuery, sessionData);
                        }
                    } else {
                        return <Fragment>
                                    <Paper className={classes.tituloContainer}>
                                        <Typography className={classes.tituloSessao}>{sessionData.nome}</Typography>
                                    </Paper>
                                <Row>
                                    <Col>
                                        <Paper>
                                            <Container className={classes.form}>
                                                <Typography variant="h1">Membros, servidores e estagiários do MPRS</Typography>
                                                <Row className={["justify-content-md-center"]}>
                                                    <Col md="auto">
                                                        <br/><br/>
                                                        <Login/>
                                                        <br/>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Paper>
                                    </Col>
                                    <Col>
                                        <Paper>
                                        <Formik
                                    initialValues={{ nome: "", email: "", cargo: "", instituicao: "", pin: null }}
                                    onSubmit={(values) => {
                                        // Não pode estar vazio e precisa ter um espaço pelo menos
                                        if (!values.nome || !values.nome.trim() || values.nome.trim().split(' ').length <= 1) {
                                            Swal.fire({
                                                title: "Campo nome inválido",
                                                text: "Favor informar seu nome completo",
                                                icon: "error",
                                                confirmButtonColor: "#ff0000",
                                                showCancelButton: false,
                                            });

                                            return false;
                                        }

                                        // Precisa ter @ e não pode ter espaço
                                        if( sessionData.acesso_via_link_requer_email && ( !values.email || !values.email.trim() || values.email.trim().split('@').length !== 2 || values.email.trim().split(' ').length > 1 ) ) {
                                            Swal.fire({
                                                title: "Campo e-mail inválido",
                                                text: "Favor informar o e-mail",
                                                icon: "error",
                                                confirmButtonColor: "#ff0000",
                                                showCancelButton: false,
                                            });

                                            return false;
                                        }

                                        // Não pode estar vazio
                                        if( sessionData.acesso_via_link_requer_instituicao && ( !values.instituicao || !values.instituicao.trim() ) ) {
                                            Swal.fire({
                                                title: "Campo instituição inválido",
                                                text: "Favor informar a instituição",
                                                icon: "error",
                                                confirmButtonColor: "#ff0000",
                                                showCancelButton: false,
                                            });

                                            return false;
                                        }

                                        // Não pode estar vazio
                                        if( sessionData.acesso_via_link_requer_cargo && ( !values.cargo || !values.cargo.trim() ) ) {
                                            Swal.fire({
                                                title: "Campo cargo inválido",
                                                text: "Favor informar seu cargo",
                                                icon: "error",
                                                confirmButtonColor: "#ff0000",
                                                showCancelButton: false,
                                            });

                                            return false;
                                        }

                                        this.handleSaveForm(values);
                                    }}
                                >
                                    {props => {
                                        const {
                                            handleChange,
                                            handleSubmit,
                                            values,
                                            errors,
                                            touched,
                                        } = props;

                                        const onChange = (event) => {
                                            handleChange(event);
                                            this.notifyChange();
                                        }


                                        return (
                                            <Form onSubmit={handleSubmit}>
                                    <Container className={classes.form}>
                                        <Typography variant="h1">Visitante</Typography>
                                        <br/>
                                        <Row>
                                            <Col sm="3"><Label htmlFor={"nome"}>Nome completo</Label></Col>
                                            <Col sm="9"><Control
                                                className={[classes.input]}
                                                id="nome"
                                                name="nome"
                                                onChange={onChange}
                                                type="text"
                                                value={values.nome}
                                                helperText={errors.nome}
                                                error={Boolean( errors.nome)}
                                            /></Col>
                                        </Row>
                                        {sessionData.acesso_via_link_requer_email ? <Row>
                                            <Col sm="3"><Label htmlFor={"email"}>E-mail</Label></Col>
                                            <Col sm="9"><Control
                                                className={[classes.input]}
                                                id="email"
                                                name="email"
                                                onChange={onChange}
                                                type="text"
                                                value={values.email}
                                            /></Col>
                                        </Row> : null }
                                        {sessionData.acesso_via_link_requer_instituicao ? <Row>
                                            <Col sm="3"><Label htmlFor={"instituicao"}>Instituição</Label></Col>
                                            <Col sm="9"><Control
                                                className={[classes.input]}
                                                id="instituicao"
                                                name="instituicao"
                                                onChange={onChange}
                                                type="text"
                                                value={values.instituicao}
                                            /></Col>
                                        </Row> : null }
                                        {sessionData.acesso_via_link_requer_cargo ?<Row>
                                            <Col sm="3"><Label htmlFor={"cargo"}>Cargo</Label></Col>
                                            <Col sm="9"><Control
                                                className={[classes.input]}
                                                id="cargo"
                                                name="cargo"
                                                onChange={onChange}
                                                type="text"
                                                value={values.cargo}
                                            /></Col>
                                        </Row> : null }
                                        <Row className={["justify-content-md-center"]}>
                                            <Col md="auto">
                                                <Button type="submit" className={classes.button}>Acessar</Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                            </Form>
                                        )
                                    }}
                                        </Formik>
                                        </Paper>
                                    </Col>
                                </Row>
                            </Fragment>;
                    }
                }}
            </Query>
        );
    }

    sessaoAgendada(sessaoDataInicio, horaAtualQuery, sessionQuery) {
        const {classes} = this.props;
        const {value: serverTime} = horaAtualQuery;

        const sessaoDataInicioUTC = moment(sessaoDataInicio).tz("UTC");
        const serverTimeUTC = moment(serverTime).tz("UTC");

        const fnDiff = () => {
            let serverTime = this.state.serverTime || serverTimeUTC;

            serverTime = serverTime.add(1, 'seconds');
            this.setState({
                serverTime
            });
        };

        if (!this.interval) {
            this.interval = setInterval(fnDiff, 1000);
            setTimeout(fnDiff, 0);
        }

        return (
            <Fragment>
                <Row>
                    <Col className={classes.flexItem}>
                        <p>{sessionQuery.nome}</p>
                        <small className={classes.footerMessage}>começará em</small>
                    </Col>
                </Row>
                <br/>
                <div className={[classes.flexItem, classes.chronometerWrapper]} style={{maxWidth: 900, margin: "auto"}}>
                    {this.renderDifference(sessaoDataInicioUTC)}
                </div>
                <div className={classes.flexItem}>
                    <small className={classes.footerMessage}>Você será redirecionado automaticamente</small>
                </div>
            </Fragment>
        );
    }

    renderDifference(inicioSessao) {
        const {classes} = this.props;
        const {serverTime} = this.state;

        const difference = moment(moment(inicioSessao) - moment(serverTime));

        const differenceDays = inicioSessao.diff(serverTime, 'days');
        const differenceHours = inicioSessao.diff(serverTime, 'hours');
        const differenceMinutes = inicioSessao.diff(serverTime, 'minutes');
        const differenceSeconds = inicioSessao.diff(serverTime, 'seconds');

        const dias = differenceDays;
        const horas = differenceHours - differenceDays * 24;
        const minutos = differenceMinutes - differenceHours * 60;
        let segundos = differenceSeconds - differenceMinutes * 60;

        if (segundos < 0)
            segundos = 0;

        return (

            <Row>
                <Col sm={12} className={classes.countDownWraper}>
                    {
                        dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(dias).padStart(2, "0")}</div>
                                <div className={classes.timerText}>DIA{(dias > 1 || dias == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    {
                        horas || dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(horas).padStart(2, "0")}</div>
                                <div className={classes.timerText}>HORA{(horas > 1 || horas == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    {
                        minutos || horas || dias
                            ? <div className={classes.countDownItem}>
                                <div className={classes.timerNumber}>{new String(minutos).padStart(2, "0")}</div>
                                <div className={classes.timerText}>MIN{(minutos > 1 || minutos == 0) ? 'S' : ''}</div>
                            </div>
                            : null
                    }
                    <div className={classes.countDownItem}>
                        <div className={classes.timerNumber}>{new String(segundos).padStart(2, "0")}</div>
                        <div className={classes.timerText}>SEG{(segundos > 1 || segundos == 0) ? 'S' : ''}</div>
                    </div>
                </Col>
            </Row>
        );
    }

    sessaoAndamento() {
        const {classes, client} = this.props;
        const {sessaoAndamentoUrl, slug, error, errorDetail, newWindow, desconhecidoSessionId} = this.state;

        if (!sessaoAndamentoUrl) {
            // Apenas faz o request uma vez
            if (!this.linkRequested) {
                this.linkRequested = true;

                client.mutate({
                    mutation: desconhecidoEntrarSessao,
                    variables: {slug, desconhecidoSessionId}
                }).then((data) => {
                    this.setState({sessaoAndamentoUrl: data.data.desconhecidoEntrarSessao});
                }).catch(e => {
                    let errorDetail = e;

                    try {
                        errorDetail = { message: e.graphQLErrors[0].debugMessage.split(' - /')[0] };
                    } catch(e2){

                    }

                    this.setState({error: "Erro ao acessar a sala", errorDetail: errorDetail});
                })
            }

            if (error) {
                return <div className={classes.flexItem}>
                    <p>{error}</p>
                    <p>{errorDetail ? errorDetail.message : null}</p>
                    <button onClick={
                        () => {
                            console.log("Tentar novamente");
                            this.linkRequested = false;
                            this.setState({sessaoAndamentoUrl: null, error: null, errorDetail: null });
                        }
                    }>Tentar novamente</button>
                </div>;
            }

            return <div className={classes.flexItem}>
                <span>Gerando link de acesso</span>
            </div>;
        } else {
            //Não deve chegar aqui, pois ou ele abre a popup, ou redireciona
            return <Fragment>
                <p>Redirecionando ...</p>
            </Fragment>;
        }
    }

}

export default (withStyles(styles)(withRouter(withApollo(DesconhecidoAcessarSala))));